export default "__VITE_ASSET__716afc37__"